// @flow
import type { ErrorAction } from '../types';

export function errorAction<C>(type: string) {
  return (message: string, context?: C): ErrorAction<C> => ({
    type,
    payload: {
      message,
      context,
    },
  });
}

export default errorAction;



// WEBPACK FOOTER //
// ./src/store/helpers/errorAction.js